interface RankListPageHeaderProps {
  title: string;
  description: string;
}


export function RankListPageHeader({ title, description }: RankListPageHeaderProps) {
  return (
    <div className="mb-3">
      <h1 className="text-xl font-semibold text-white">{title}</h1>
      <p className="text-[#8f98a0] text-sm mt-0.5">{description}</p>
    </div>
  );
}
